import { StatusContainer } from '@servicetitan/financing-utils-shared';
import { useProviderConfig } from '@servicetitan/financing-workflow-shared';
import ReviewingIllustration from '../../common/illustrations/reviewing.svg';
import { VerticalStepper, type StepItem } from './VerticalStepper';

export type ApplicationState = 'sending' | 'reviewing' | 'approved' | 'declined';

export type TurnsState = 'sending' | 'reviewing' | 'approved' | 'declined' | 'none';

interface ReviewingProps {
    applicationState: ApplicationState;
    turnsState: TurnsState;
}

export const Reviewing = ({ applicationState, turnsState = 'none' }: ReviewingProps) => {
    const providerConfig = useProviderConfig();

    const steps: StepItem[] = [];

    if (applicationState === 'sending') {
        steps.push({
            label: providerConfig.submittingLabel ?? 'Submitting Application',
            description: 'Your application is being submitted.',
            completed: false,
        });
    } else {
        steps.push({
            label: providerConfig.submittedLabel ?? 'Application Submitted',
            description: 'Your request has been sent.',
            completed: true,
        });
    }

    if (applicationState === 'reviewing') {
        steps.push({
            label: providerConfig.reviewingNow ?? 'Reviewing now',
            description: providerConfig.reviewingNowDescription ?? 'Checking if you qualify.',
            completed: false,
        });
    } else if (applicationState === 'approved') {
        steps.push({
            label: providerConfig.reviewingNowComplete ?? 'Review Complete',
            description: '',
            completed: true,
        });
    } else if (applicationState === 'declined') {
        steps.push({
            label: providerConfig.reviewingNowComplete ?? 'Review Complete',
            description: providerConfig.reviewingDeclined ?? 'Unable to prequalify you.',
            completed: true,
        });
    }

    if (turnsState === 'reviewing') {
        steps.push({
            label: 'Turns is Reviewing Now',
            description: 'Exploring additional financing options.',
            completed: false,
        });
    } else if (turnsState === 'approved') {
        steps.push({
            label: 'Turns Review Complete',
            description: '',
            completed: true,
        });
    } else if (turnsState === 'sending') {
        steps.push({
            label: 'Submitting Turns Application',
            description: 'Sending your information to Turns.',
            completed: false,
        });
    }

    return (
        <StatusContainer headline="Reviewing your information" image={ReviewingIllustration}>
            <VerticalStepper steps={steps} />
        </StatusContainer>
    );
};
